export default {
	vipBenefits: {
		salaryTitle: 'VIP給与',
		benefitsTitle: '特典',
		yourVipProgress: 'VIP進捗',
		progressToVip: 'VIP {level}まで{percent}%',
		vipMax: '最高レベル達成',
		vipLevelBenefits: 'VIPレベル＆特典',
		betXpRule: 'ベット{amount} = {xp}EXP',
		btnReceive: '受け取る',
		btnJoinIn: '参加する',
		btnReceived: '受取済み',
		btnExpired: '期限切れ',
		btnNotSettled: '未精算',
		btnComingSoon: '近日公開',
		btnViewMore: 'もっと見る',
		btnContactNow: 'お問い合わせ',
		guestTitleLevelup: 'レベルアップボーナス',
		guestTitleDaily: 'デイリーサラリー',
		guestTitleWeekly: 'ウィークリーサラリー',
		guestTitleMonthly: 'マンスリーサラリー',
		guestTitleCashback: 'キャッシュバック',
		guestTitleRescue: 'レスキューボーナス',
		guestTitleEvents: 'VIPイベント',
		guestTitleSupport: 'VIPサポート',
		guestDescLevelup: '新しいVIPレベルに到達するたびに一度限りのボーナスを獲得。',
		guestDescDaily: 'VIPレベルが上がると毎日サラリー報酬を受け取れます。',
		guestDescWeekly: 'VIPレベルが上がると毎週サラリー報酬を受け取れます。',
		guestDescMonthly: 'VIPレベルが上がると毎月サラリー報酬を受け取れます。',
		guestDescCashback: 'ゲームの利用額に応じてキャッシュバックを獲得。',
		guestDescRescue: '立て直しを助けるレスキューボーナスを獲得。',
		guestDescEvents: 'VIPレベルが高いほど、より多くの限定イベント報酬がアンロックされます。',
		guestDescSupport: '迅速な対応のための専用VIPサポート。',
		comingSoonHint: '特典は近日公開予定です',
		receiveSuccess: '報酬を受け取りました',
		receiveFailed: '報酬の受け取りに失敗しました',
		typeUpgrade: 'レベルアップボーナス',
		typeDailySalary: '日給',
		typeWeeklySalary: '週給',
		typeMonthlySalary: '月給',
		typeRebate: 'キャッシュバック',
		typeRescue: 'レスキューボーナス',
		typeVipActivity: 'VIPイベント',
		typeVipService: 'VIPサポート',
		tooltipRecharge: 'チャージ {current}/{target}',
		tooltipBets: 'ベット {current}/{target}',
		progressRecharge: 'チャージ',
		progressBets: 'ベット',
		descUpgradeBonus: 'VIP{level} アップグレードボーナス ×{count}',
		descDailySalary: 'VIP{level} 日給 ×{count}',
		descWeeklySalary: 'VIP{level} 週給 ×{count}',
		descMonthlySalary: 'VIP{level} 月給 ×{count}',
		descUpgradeBonusPlain: 'VIP{level} アップグレードボーナス',
		descDailySalaryPlain: 'VIP{level} 日給',
		descWeeklySalaryPlain: 'VIP{level} 週給',
		descMonthlySalaryPlain: 'VIP{level} 月給',
		descRebate: 'VIP{level} ゲームキャッシュバック',
		descRescue: 'VIP{level} レスキューボーナス',
		descVipActivity: 'VIPレベルが高いほど、より多くの限定イベント報酬がアンロックされます。',
		descVipService: '迅速な対応のための専用VIPサポート。',
		allBenefits: 'すべての特典',
		vipClubTitle: 'VIP Club',
		more: 'もっと見る',
		moreDesc: '詳細はプロモーションをご覧ください。',
		promotions: 'プロモーション',
		highlightsTitle: '8つの特典ハイライト',
		highlightSupport: 'VIP専用サポート',
		highlightLevelup: 'レベルアップボーナス',
		highlightSalary: 'VIP給与',
		highlightRescue: 'VIPレスキューボーナス',
		highlightGifts: 'VIP限定\nギフト',
		highlightEvents: 'VIPイベント',
		highlightService: 'VIP専用\nサービス',
		highlightWallet: 'VIP\nクレジットウォレット',
		currentLevel: '現在のレベル',
		keepPlayingReach: 'プレイを続けて到達しよう',
		higherLevelRewards: 'レベルが高いほど、報酬も豪華に',
		levelUpUnlock: 'レベルアップして限定特典を解除し、プレミアムな体験をお楽しみください。',
		yourVipBenefits: 'あなたのVIP特典',
		viewVipLevels: 'VIPレベルを見る',
		exclusiveBenefitsTitle: 'あなたの限定特典',
		tipExclusiveRewards: '限定報酬',
		tipHigherRakeback: 'より高いリベート',
		tipPrioritySupport: '優先サポート',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'レベル',
		tableRequiredXp: '必要EXP',
		tableLevelUpBonus: 'レベルアップボーナス',
		tableDailyRakeback: 'デイリーリベート',
		tableWeeklyLossback: 'ウィークリー損失還元',
		signIn: 'ログイン',
		vipClubDefaultDesc: '今すぐVIP Clubに参加して、ギフトやプレゼント、豪華な特典を受け取りましょう。',
	},
};
